import React, { memo } from 'react'

type FigreType = {
  images: string
  thumnail: boolean
  active?: string
}

export const Figure: React.FC<FigreType> = memo(
  ({ images = 'img_thumnail.jpg', thumnail, active }) => {
    return (
      <>
        {thumnail ? (
          <>
            <figure className={`thumbnail ${active}`}>
              <img src={`${images}`} alt="" />
            </figure>
          </>
        ) : (
          <figure>
            <img src={`/images/${images}`} alt="" />
          </figure>
        )}
      </>
    )
  }
)

Figure.displayName = 'Figure'
